<template>
  <div>
    <form-template :references.sync="formReferences" :model="ticketObj" ref="ticketReference">
      <template slot="extraDetails">
        <v-container fluid>
          <v-layout wrap class="">
            <template>
            <v-flex lg6 class="mb-3">
              <v-text-field :label="$t('message.product.attachments')" @click='pickFile' prepend-icon='mdi-paperclip' dense outlined hide-details></v-text-field>
              <input type="file" style="display: none" id="attachments" ref="attachments" @change="onFilePicked" multiple>
            </v-flex>
            <v-flex lg6></v-flex>
            <v-flex lg1 v-for="(image, index) in listOfFiles" :key="`image_${index}`" class="ma-1 elevation-1">
              <v-hover v-slot="{ hover }">
                <v-img :src="image.base64" height="80" :aspect-ratio="16/9" width="200" contain>
                <v-expand-transition>
                    <div v-if="hover"  class="d-flex transition-fast-in-fast-out primary darken-2 v-card--reveal display-3 white--text" style="height: 100%;">
                      <v-icon class="px-9" @click="removeAttachment(index, 'listOfFiles', image.id)" dark>mdi-close-circle-outline</v-icon>
                    </div>
                  </v-expand-transition>
                </v-img>
              </v-hover>
            </v-flex>
            <v-flex lg2 v-for="(files, index) in listOfOtherFiles" :key="`file_${index}`">
              <v-card outlined height="50" color="ma-1">
                <div class="attchment custom_py-2">
                  <v-row class="ma-0">
                    <v-col lg="1" class="pa-1">
                      <v-icon :color="files.color">{{ files.icon }}</v-icon>
                    </v-col>
                      <v-col lg="8" class="text-truncate pa-1 pl-3">
                      <span class="caption">{{ files.name }}</span>
                      </v-col>
                      <v-col lg="2" class="pa-1">
                        <v-icon color="error" @click="removeAttachment(index, 'listOfOtherFiles', files.id)">mdi-close-circle-outline</v-icon>
                      </v-col>
                  </v-row>
                </div>
              </v-card>
            </v-flex>
          </template>
          <v-flex lg12 xs12>
            <span v-if="type">{{$t('message.tickets.description')}}</span>
            <span v-else>{{$t('message.tickets.body')}}</span>
            <div class="ticket-editor">
              <ckeditor :editor="editor" v-model="ticketObj.body" :config="editorConfig" ref="editor" :key="render"></ckeditor>
            </div>
          </v-flex>
          </v-layout>
        </v-container>
      </template>
    </form-template>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters, mapState } from 'vuex'
import FormTemplate from '../../components/FormTemplate'
import Editor from '@/ckeditor'
export default {
  data () {
    return {
      MODULE_URL: 'tickets',
      type: this.$route.query.type === 'task' ? true : false,
      ticketObj: {
        to: [],
        is_task: this.$route.query.type === 'task',
        body: this.$route.query.type === 'task' ? '' : `<br><div class="content"><iframe id="userSignFooter" frameborder="0" width="100%"></iframe></div>`
        // body:  this.$route.query.type === 'task' ? '' : this.$store.state.userDetails.signature ? `<div><p></p><p style="white-space: pre-wrap;">${this.$store.state.userDetails.signature.replace('\n', '<br>')}</p></div>` : ''
      },
      loading: false,
      editor: Editor,
      editorConfig: {},
      loader: false,
      emailRegex: /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/,
      isLoading: false,

      listOfCustomers: [],
      customerLoading: false,
      enableSearch: true,
      render: 0,
      modulesRelated: [],
      attachmentsList: [],
      attachmentsFiles: [],
      listOfFiles: [],
      listOfOtherFiles: [],
      settingsObj: {}
    }
  },
  components: {
    FormTemplate,
  },
  computed: {
    ...mapState(['FORM_TYPE', 'listOfUsers', 'listOfUserGroupMailboxes', 'listOfTicketPriorities', 'listOfTicketStatus', 'listOfGroups', 'listOfTicketCategories']),
    formReferences () {
      let item = {
        title: this.$route.query.type === 'task' ? this.$t('message.tickets.createTask') : this.$t('message.tickets.createTicket'),
        properties: [{
          model: 'subject',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.tickets.subject'),
          class: 'lg4 sm4 xs12'
        }, {
          model: 'to',
          type: this.FORM_TYPE.COMBOBOX,
          rules: this.$_multiSelectValidation,
          items: [],
          class: 'lg4 sm4 xs12',
          label: this.$t('message.tickets.to'),
          is_visible: !this.ticketObj.is_task
        }, {
          model: 'cc',
          type: this.FORM_TYPE.COMBOBOX,
          items: [],
          class: 'lg4 sm4 xs12',
          label: this.$t('message.tickets.cc'),
          is_visible: !this.ticketObj.is_task
        }, {
          model: 'bcc',
          type: this.FORM_TYPE.COMBOBOX,
          items: [],
          class: 'lg4 sm4 xs12',
          label: this.$t('message.tickets.bcc'),
          is_visible: !this.ticketObj.is_task
        }, {
          model: 'customerid',
          live_search_model: 'customerSearch',
          type: this.FORM_TYPE.AUTO_COMPLETE_LIVE,
          items: this.listOfCustomers,
          select_text: 'name',
          select_value: 'id',
          rules: [],
          class: 'lg3 sm4 xs12',
          label: this.$t('message.order.customer'),
          loading: this.customerLoading
        }, {
          model: 'assignedto',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.getUsersAndGroups,
          rules: this.$_requiredValidation,
          select_text: 'fullname',
          select_value: 'alternateid',
          class: 'lg2 sm4 xs12',
          label: this.$t('message.tickets.assignedTo')
        }, {
          model: 'mailboxid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listOfUserGroupMailboxes,
          select_text: 'mailboxname',
          select_value: 'mailboxid',
          class: 'lg2 sm4 xs12',
          rules: this.$_requiredValidation,
          label: this.$t('message.tickets.mailbox'),
          is_visible: !this.ticketObj.is_task
        }, {
          model: 'status',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listOfTicketStatus,
          rules: this.$_requiredValidation,
          select_text: 'name',
          select_value: 'id',
          class: 'lg2 sm4 xs12',
          label: this.$t('message.tickets.status')
        }, {
          model: 'priority',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listOfTicketPriorities,
          select_text: 'name',
          select_value: 'id',
          class: 'lg2 sm4 xs12',
          label: this.$t('message.tickets.priority')
        }, {
          model: 'category_id',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listOfTicketCategories,
          select_text: 'name',
          select_value: 'id',
          class: 'lg2 sm4 xs12',
          label: this.$t('message.settings.category')
        }/* , {
          model: 'tags',
          type: this.FORM_TYPE.COMBOBOX,
          rules: [],
          multiple: true,
          items: [],
          label: this.$t('message.tickets.tags'),
          class: 'lg3 sm4 xs12 pt-2'
        } */],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.ticketObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loader,
          is_show: true
        }, {
          name: 'close',
          color: 'info',
          // eslint-disable-next-line
          click: () => this.$router.push(`/${this.MODULE_URL}`),
          label: this.$t('message.common.backToList'),
          is_show: true
        }]
      }
      return item
    },
    getUsersAndGroups () {
      let userList = this.$formatter.cloneVariable(this.listOfUsers)
      let groupList = this.$formatter.cloneVariable(this.listOfGroups)
      let list = [ ...userList, ...groupList ]
      return list
    }
  },
  async mounted () {
    this.$store.dispatch('getUserGroupMailbox')
    await this.getInvoiceSettings()
    const { mail_signature } = this.$formatter.cloneVariable(this.settingsObj)
    if (!this.ticketObj.id) {
      this.ticketObj.body = `<br/>${mail_signature}`
    }
    let ticketBody = `<br/>${mail_signature} ${this.ticketObj.body}`
    this.$store.dispatch('getGroups')
    this.$store.dispatch('getUsers').then(() => {
      if (!this.ticketObj.id) {
        this.setDefaultValues({ prop: 'assingedto', list: this.listOfUsers })
      }
      // To Convert task to ticket / ticket to task
      if (this.$route.query && this.$route.query.type) {
        let ticketInfo = JSON.parse(window.localStorage.getItem('taskOrTicketInfo'))
        if (ticketInfo) {
          this.enableSearch = false
          ticketInfo.body = `${ticketInfo.body} ${ticketBody}`
          let ticketObj = {
            ...ticketInfo,
            is_task : this.type,
            parenttaskid: !this.type ? ticketInfo.id : undefined,
            deleteparenttask: !this.type ? false : undefined,
            deleteparentticket: this.type ? false : undefined,
            parentticketid: this.type ? ticketInfo.id : undefined,
            cc: '',
            bcc: '',
            from: '',
            id: null,
            mailboxid: null
          }
          this.ticketObj = Object.assign({}, this.ticketObj, ticketObj)
          if (ticketInfo.customers && ticketInfo.customers.length) this.listOfCustomers = ticketInfo.customers
          this.render++
          setTimeout(() => { this.enableSearch = true })
        }
      }
      /* Set signature only after users loaded */
      if (this.$route.query.type !== 'task' && !this.type && (!!document.getElementById("userSignFooter"))) {
        setTimeout(() => {
          let item = ''
          let currentUser = this.listOfUsers.find(x => x.id === this.$store.state.userDetails.id)
          if (currentUser && currentUser.signature) {
            item = `${currentUser.signature}`
            document.getElementById("userSignFooter").srcdoc = item
            setTimeout(() => {
              let element = document.getElementById('userSignFooter')
              element.style.height = (element.contentWindow.document.all[2].offsetHeight + 30) + 'px'
              element.style.pointerEvents = 'none'
            }, 350)
          }
        }, 150)
      }
    })
    this.$store.dispatch('getStatus').then(() => {
      if (!this.ticketObj.id) {
        this.setDefaultValues({ prop: 'status', list: this.listOfTicketStatus })
      }
    })
    this.$store.dispatch('getPriority').then(() => {
      if (!this.ticketObj.id) {
        this.setDefaultValues({ prop: 'priority', list: this.listOfTicketPriorities })
      }
    })
    this.$store.dispatch('getTicketCategory').then(() => {
      if (!this.ticketObj.id) {
        this.setDefaultValues({ prop: 'category_id', list: this.listOfTicketCategories })
      }
    })
  },
  watch: {
    'ticketObj.assignedto' (val) {
      if (this.ticketObj.status !== parseInt(process.env.VUE_APP_TICKET_STAUS_INPROGRESS)) this.ticketObj.status = parseInt(process.env.VUE_APP_TICKET_STAUS_INPROGRESS)
    },
    'ticketObj.customerSearch' (val) {
      if (val === undefined) return
      if (val && !val.includes('-') && this.enableSearch) this.loadCustomerList(val)
    }
  },
  methods: {
    setDefaultValues (data) {
      let { list, prop } = data
      let item = list.find(x => x.isdefault)
      let model = {}
      if (item) {
        model = Object.assign({ ...this.ticketObj }, { [prop]: item.id })
        this.ticketObj = model
      }
    },
    supportingList (type, text) {
      text = this.$refs.ticketReference.$refs[text][0].lazySearch
      let model = { module: type, dialog: true, text }
      this.$store.commit('supportingList', model)
    },
    loadCustomerList (searchTerm) {
      this.customerLoading = true
      this.listOfCustomers = []
      this.$_executeApi('get', `customers/search?search_term=${searchTerm}`).then((response) => {
        this.listOfCustomers = response.data
      }).finally(() => {
        this.customerLoading = false
      })
    },
    async saveAttachmentsHandler () {
      var formData = new FormData()
      var filesList = this.attachmentsFiles
      if (filesList !== null && filesList.length > 0) {
        filesList.forEach(file => {
          formData.append(file.name, file)
        })
      }
      return new  Promise((resolve, reject) => {
        this.$_executeApi('post', 'mailattachments/upload', formData).then(response => {
          if (response.data && response.data.length > 0) {
            let attachmentIds = response.data.map(x => x.id)
            resolve(attachmentIds)
            // this.$set(this.ticketObj, 'attachments', attachmentIds)
          }
        })
      })
    },
    async saveUpdateHandler () {
      if (this.$refs.ticketReference.$refs.validateForm.validate()) {
        let ticketObj = this.$formatter.cloneVariable(this.ticketObj)
        ticketObj.body = ticketObj.body.replace('<div class="content"><iframe id="userSignFooter" frameborder="0" width="100%"></iframe></div>', '')
        ticketObj.body = ticketObj.body.replace('<div class="content"><iframe width="100%" frameborder="0" id="userSignFooter"> </iframe></div>', '')
        let to = this.ticketObj.to || []
        let cc = ticketObj.cc ? ticketObj.cc : []
        let bcc = this.ticketObj.bcc ? ticketObj.bcc : []
        if (!this.type) {
          let arrayOfEmails = [...to, ...cc, ...bcc]
          if (arrayOfEmails.length > 0) {
            for (let email of arrayOfEmails) {
              if (!this.emailRegex.test(email)) {
                this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.invalidEmail') })
                return false
              }
            }
          }
        }
        this.loader = true
        if (this.listOfFiles.length > 0 || this.listOfOtherFiles.length > 0) ticketObj.attachments = await this.saveAttachmentsHandler()
        let url = `${this.MODULE_URL}/create`
        let model = ticketObj
        model.tags = JSON.stringify(model.tags)
        let assignedTo = []
        if (model.assignedto) {
          assignedTo = model.assignedto.split('_')
          if (assignedTo[0] === 'user') {
            model.assignedto = assignedTo[1]
            model.assignedto_group =  0
          } else {
            model.assignedto = 0
            model.assignedto_group =  assignedTo[1]
          }
        }
        if (this.type) model.is_task = true
        else model.is_task = false
        if (model.is_task) model = this.$_removeEmptyFromObject(model)
        this.$_saveUpdateHandler(url, model).then(response => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.addedSucess') })
          this.$router.push(`/${this.MODULE_URL}/actions/${response.id}`)
          window.localStorage.removeItem('taskOrTicketInfo')
          if (assignedTo.length > 0 && this.$store.state.userDetails.id != model.assignedto[1]) {
            let  msg = ''
            if (assignedTo[0] === 'user') {
              msg = `${this.$t('message.tickets.assignedtoMessage')} ${response.number} ${this.$t('message.tickets.by')} ${this.$store.state.userDetails.name}`
              this.$eventBus.$emit('SendNotification', [parseInt(assignedTo[1])], msg, response.id)
            } else {
              // let item = this.listOfGroups.find(x => x.id == assignedTo[1])
              // let usersarray = []
              // let query = { filter: `groupid eq ${assignedTo[1]} and isactive eq 1` }
              // msg = `${item.name} ${this.$t('message.common.assignedFor')} ${response.number} ${this.$t('message.tickets.by')} ${this.$store.state.userDetails.name}`
              // this.$_executeApi('get', `usergroups/get_by_group/${assignedTo[1]}`).then(result => {
              //   usersarray = result.data.map(x => x.user_id)
              // }).finally(() => {
              //   this.getsignalRConnection.invoke('SendNotification', usersarray, msg, response.id)
              // })
            }
          }
        }).finally(() => {
          this.loader = false
        })
      }
    },
    pickFile () {
      this.$refs.attachments.click()
    },
    async onFilePicked (e) {
      const files = e.target.files
      for (let file of files) {
        if (file) {
          file.uniqueId = this.$_getRandomNumberInBW(10, 10000)
          this.attachmentsList.push(file.name)
          this.attachmentsFiles.push(file)
          if (this.imagesTypes.includes(file.type)) {
            let base64 = await this.toBase64(file)
            this.listOfFiles.push({ id: file.uniqueId, base64 })
          } else {
            let iconObj = this.getMimeTypeIcons(file.type)
            this.listOfOtherFiles.push({ name: file.name, type: file.type, ...iconObj, id: file.uniqueId })
          }
        }
      }
    },
    getInvoiceSettings () {
      return this.$_getSingleRecordHandler('invoicesettings')
        .then((result) => {
          if (result.data) this.settingsObj = result.data
        })
    },
    /* Attachments */
    removeAttachment (index, listname, id) {
      const sourceFileIndex = this.attachmentsFiles.findIndex(x => x.uniqueId === id)
      this[listname].splice(index, 1)
      if (sourceFileIndex > -1) this.attachmentsFiles.splice(sourceFileIndex, 1)
    },
    /* --- */
  },
  destroyed () {
    window.localStorage.removeItem('taskOrTicketInfo')
  }
}
</script>
<style>
.combo .v-text-field .v-input__append-inner {
  display: none!important;
}
.ck-editor__editable_inline {
    min-height: 100px;
}
.ck-focused, .ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused {
  border-color: #c4c4c4!important;
   box-shadow: 0 0 0px 1px #6cb5f9!important;
   border: #c4c4c4 !important;
}
.ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
  border-color: #c4c4c4 !important;
}
.custom_py-2 {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
</style>
